import { alpha, Button, CircularProgress, useColorScheme } from "@mui/material";
import { Constants } from "../../utils/constants";


export default function MainButton({
  text,
  size = "large",
  preIcon = null,
  type = "button",
  fullWidth = true,
  onClick = () => { },
  disabled = false,
  isSubmitting = false,
  sx,
}) {
  const { mode } = useColorScheme();
  const currentMode = mode || "light";
  return (
    <Button
      onClick={isSubmitting ? () => { } : onClick}
      size={size}
      variant="contained"
      startIcon={preIcon}
      disabled={disabled}
      fullWidth={fullWidth}
      type={type}
      sx={{
        ...sx,
        backgroundColor: Constants.Colors[currentMode].accent,
        color: Constants.Colors[currentMode].accentForeground,
        borderRadius: "6px",
        boxShadow: "none",
        textTransform: "none",
        "&:hover": {
          boxShadow: "none",
          backgroundColor: alpha(Constants.Colors[currentMode].accent, 0.9),
        }
      }}
    >
      {isSubmitting ? <CircularProgress color="success" size={20} /> : text}
    </Button>
  );
}